import IconNew from '@hubins/components/IconNew';
import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './NavigationSidebarItem.scss';

interface NavigationSidebarItemProps {
  label: string;
  to: string;
  icon?: string;
  external?: boolean;
  active?: boolean;
}

interface NavigationSidebarItemLinkProps {
  to: string;
  external?: boolean;
  active?: boolean;
  children: React.ReactNode;
}

const NavigationSidebarItemLink = ({ to, external = false, active, children }: NavigationSidebarItemLinkProps) => {
  return (
    !external ? (
      <Link to={to} className={`navigation-sidebar-item ${active ? 'navigation-sidebar-item--active' : ''}`}>
        {children}
      </Link>
    ) : (
      <a href={to} className={`navigation-sidebar-item ${active ? 'navigation-sidebar-item--active' : ''}`}>
        {children}
      </a>
    )
  );
};

const NavigationSidebarItem = ({ label, to, icon, external = false, active }: NavigationSidebarItemProps) => {
  const location = useLocation();

  const [isActive, setIsActive] = useState(active);

  useEffect(() => {
    setIsActive(location.pathname === to);
  }, [location.pathname]);

  return <NavigationSidebarItemLink to={to} external={external} active={isActive}>
    <p className="navigation-sidebar-item__container">
      {icon && <IconNew icon={icon} size={16} />}
      {label}
    </p>
  </NavigationSidebarItemLink>
};

export default NavigationSidebarItem;
